import { useQuery, useQueryClient } from "@tanstack/react-query";
import { InvoiceCell } from "@/components/InvoiceCell";
import { useApi } from "@/lib/useApi";
import { formatEUR, formatDate } from "@/lib/api";

export default function ResellerCommissions() {
  const api = useApi();
  const qc = useQueryClient();
  const refresh = () => qc.invalidateQueries({ queryKey: ["reseller-commissions"] });
  const { data } = useQuery({
    queryKey: ["reseller-commissions"],
    queryFn: async () => (await api.get("/reseller/commissions")).data,
  });
  const items = data?.items || [];

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Provvigioni</h1>
        <p className="text-sm text-slate-500 mt-1">Dettaglio delle Sue provvigioni maturate e liquidate. Alleghi una fattura per ogni mese: vale per tutte le provvigioni di quel mese.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white border border-[#E2DDD5] rounded-xl p-5"><div className="text-xs uppercase tracking-wider text-slate-500">Totale maturato</div><div className="text-2xl font-bold mt-2">{formatEUR(data?.totals?.earned)}</div></div>
        <div className="bg-white border border-[#E2DDD5] rounded-xl p-5"><div className="text-xs uppercase tracking-wider text-slate-500">Liquidato</div><div className="text-2xl font-bold mt-2 text-emerald-700">{formatEUR(data?.totals?.paid)}</div></div>
        <div className="bg-white border border-[#E2DDD5] rounded-xl p-5"><div className="text-xs uppercase tracking-wider text-slate-500">Da liquidare</div><div className="text-2xl font-bold mt-2 text-amber-700">{formatEUR(data?.totals?.pending)}</div></div>
      </div>
      <div className="overflow-x-auto rounded-xl border border-[#E2DDD5] bg-white">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-wider text-slate-500 bg-[#F2F0EB]">
            <tr>
              <th className="text-left px-3 py-3">Periodo</th>
              <th className="text-left px-3 py-3">Importo</th>
              <th className="text-left px-3 py-3">Cliente / Prodotto</th>
              <th className="text-left px-3 py-3">Stato</th>
              <th className="text-left px-3 py-3">Creata</th>
              <th className="text-left px-3 py-3">Fattura del mese</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="px-3 py-6 text-center text-slate-500">Nessuna provvigione.</td></tr>}
            {items.map((c) => (
              <tr key={c.id} className="border-t border-[#E2DDD5]" data-testid={`r-comm-${c.id}`}>
                <td className="px-3 py-3 font-mono text-xs">{c.period}</td>
                <td className="px-3 py-3 font-semibold">{formatEUR(c.amount)}</td>
                <td className="px-3 py-3 text-xs"><div>{c.customer_name || "—"}</div><div className="text-slate-500">{c.product_name || ""}</div>{c.note && <div className="text-slate-500 italic">{c.note}</div>}</td>
                <td className="px-3 py-3 capitalize"><span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${c.status === "paid" ? "bg-emerald-100 text-emerald-900 border-emerald-300" : "bg-amber-100 text-amber-900 border-amber-300"}`}>{c.status === "paid" ? "Liquidata" : "In attesa"}</span></td>
                <td className="px-3 py-3 text-slate-500">{formatDate(c.created_at)}</td>
                <td className="px-3 py-3"><InvoiceCell api={api} row={c} uploadUrl="/reseller/commission-invoices" onDone={refresh} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
